export const ARTICLES_PART4 = [
  {
    slug: "be-florence-palto-i-pukhoviki",
    title: "Be Florence: итальянская элегантность на каждый день",
    seoTitle: "Be Florence — пальто и пуховики: купить в Алматы | Angiolini",
    description:
      "Бренд Be Florence: пальто и пуховики в стиле quiet luxury — чистые линии, натуральные материалы, меховая отделка. Обзор коллекции и где купить в Казахстане.",
    date: "2026-07-17",
    readTime: "5 мин",
    tag: "Be Florence",
    image: "/media/cover-c.jpg",
    sections: [
      {
        h: "Философия тихой роскоши",
        ps: [
          "Be Florence не кричит о себе логотипами. Узнаваемость бренда — в другом: идеальная посадка, благородные оттенки и материалы, которые хочется трогать. Это одежда, в которой каждый день чувствуешь себя собранно и дорого.",
          "Дизайнеры марки вдохновляются гардеробом флорентийских аристократок: ничего лишнего, только выверенные пропорции и качество, заметное с первого взгляда.",
        ],
      },
      {
        h: "Что искать в коллекции",
        ps: [
          "Фирменные вещи Be Florence — пальто из шерсти и альпаки с отделкой из норки в тон, лёгкие стёганые модели на межсезонье и пуховики с чистым минималистичным дизайном.",
          "Палитра — сдержанная: молочный, серо-бежевый, капучино, графит. Такие вещи сочетаются со всем гардеробом и не устаревают через сезон.",
        ],
      },
      {
        h: "Be Florence в Казахстане",
        ps: [
          "Angiolini — официальная точка бренда в Алматы: коллекция Be Florence представлена в шоуруме в Нурлы Тау и в каталоге приложения.",
          "Откройте приложение Angiolini, чтобы посмотреть модели и цены, забронировать размер и записаться на примерку — бонусы за регистрацию можно потратить на покупку.",
        ],
      },
    ],
  },
  {
    slug: "torriss-pukhoviki-premium",
    title: "Torriss: тёплые пуховики премиум-класса для города",
    seoTitle: "Torriss — купить пуховик премиум-класса в Алматы | Angiolini",
    description:
      "Пуховики Torriss: мембранные ткани, гусиный пух, меховые капюшоны и городской крой. Почему Torriss выбирают на суровую зиму и где примерить бренд в Алматы.",
    date: "2026-07-20",
    readTime: "5 мин",
    tag: "Torriss",
    image: "/media/cover-a.jpg",
    sections: [
      {
        h: "Инженерный подход к теплу",
        ps: [
          "Torriss проектирует пуховики как техничную экипировку, но одевает их в элегантную городскую форму. Мембранные ткани не пропускают ветер и мокрый снег, отборный пух держит тепло до -30, а швы проклеены, чтобы не оставить холоду ни шанса.",
          "При этом силуэты остаются женственными: приталенные линии, аккуратные капюшоны с меховой отделкой, длина, закрывающая колено, — идеальный баланс практичности и стиля.",
        ],
      },
      {
        h: "Детали, за которые любят Torriss",
        ps: [
          "Двусторонние молнии для удобства за рулём, ветрозащитные планки, внутренние манжеты, скрытые карманы для телефона — каждая мелочь продумана для реальной городской зимы.",
          "Меховая отделка капюшона у большинства моделей съёмная: один пуховик — два образа, строгий и роскошный.",
        ],
      },
      {
        h: "Примерка в Алматы",
        ps: [
          "Коллекция Torriss доступна в шоуруме Angiolini в Нурлы Тау. Размеры быстро разбирают в сезон — проверяйте наличие в приложении и бронируйте примерку заранее.",
          "Регистрация в приложении Angiolini занимает меньше минуты и сразу приносит приветственные бонусы.",
        ],
      },
    ],
  },
  {
    slug: "pukhovik-ili-palto-s-mekhom",
    title: "Пуховик или пальто с мехом: что выбрать на зиму",
    seoTitle: "Пуховик или пальто с мехом — что теплее и практичнее | Angiolini",
    description:
      "Пуховик или пальто с меховой отделкой: сравниваем тепло, практичность, стиль и уход. Честный гид, который поможет выбрать верхнюю одежду на зиму.",
    date: "2026-07-23",
    readTime: "6 мин",
    tag: "Гид",
    image: "/media/cover-c.jpg",
    sections: [
      {
        h: "Тепло и погода",
        ps: [
          "Премиальный пуховик выигрывает в мороз и ветер: пух с высоким fill power и мембрана держат тепло даже при -30. Это выбор для тех, кто много ходит пешком и проводит время на улице.",
          "Пальто с меховой отделкой комфортно до -15…-20: кашемир и шерсть дышат, а мех прикрывает шею и грудь. Для города с поездками на автомобиле этого более чем достаточно.",
        ],
      },
      {
        h: "Стиль и уместность",
        ps: [
          "Пальто — универсальнее: оно уместно в офисе со строгим дресс-кодом, на деловой встрече и вечером в ресторане. Меховая отделка добавляет статусности без избыточности.",
          "Современные премиальные пуховики давно перестали быть «спортивными»: модели MARCO DEL FORTE или Torriss с поясом и меховым капюшоном выглядят не менее элегантно, а свободы движений дают больше.",
        ],
      },
      {
        h: "Практичный ответ",
        ps: [
          "Идеальный зимний гардероб включает и то и другое: пальто с норковой отделкой — на каждый день и выходы, пуховик — на морозы, поездки и активные дни.",
          "В каталоге Angiolini обе категории собраны в одном месте: сравнивайте модели, цены и размеры в приложении и записывайтесь на примерку в шоуруме в Алматы.",
        ],
      },
    ],
  },
  {
    slug: "s-chem-nosit-palto-s-mekhom",
    title: "С чем носить пальто с меховой отделкой: гид по стилю",
    seoTitle: "С чем носить пальто с мехом — образы и сочетания | Angiolini",
    description:
      "С чем носить пальто с норковой и соболиной отделкой: готовые образы на каждый день, в офис и на вечер. Советы стилистов Angiolini и модные сочетания 2026.",
    date: "2026-07-26",
    readTime: "5 мин",
    tag: "Стиль",
    image: "/media/cover-d.jpg",
    sections: [
      {
        h: "Каждый день: расслабленный шик",
        ps: [
          "Самое модное сочетание сезона — пальто с меховой планкой, прямые джинсы и объёмная кепка или бини. Контраст роскошного меха и денима делает образ современным и снимает излишнюю парадность.",
          "Обувь — грубые ботинки, лоферы на массивной подошве или белые кроссовки в сухую погоду. Сумка — структурная, среднего размера.",
        ],
      },
      {
        h: "Офис и деловые встречи",
        ps: [
          "К строгому дресс-коду выбирайте пальто в тёмных оттенках с мехом в тон: графит, шоколад, чёрный. Под низ — костюм или трикотажное платье, обувь — сапоги на устойчивом каблуке.",
          "Правило одного акцента: если мех выразительный, украшения и аксессуары должны быть минимальными.",
        ],
      },
      {
        h: "Вечер: максимум эффекта",
        ps: [
          "Для вечернего выхода работает длина макси: пальто-кейп с соболиной отделкой поверх платья-комбинации или костюма с широкими брюками выглядит эффектнее любой шубы.",
          "Подобрать своё пальто можно в каталоге Angiolini — а ИИ-примерка в приложении покажет, как модель сядет именно на вас, ещё до визита в шоурум.",
        ],
      },
    ],
  },
  {
    slug: "ukhod-za-pukhovikom-i-palto",
    title: "Как ухаживать за премиальным пуховиком и пальто с норкой",
    seoTitle: "Уход за пуховиком и пальто с мехом — правила | Angiolini",
    description:
      "Как стирать и хранить премиальный пуховик, как ухаживать за пальто с норковой отделкой: правила чистки, сушки и летнего хранения от экспертов Angiolini.",
    date: "2026-07-29",
    readTime: "6 мин",
    tag: "Уход",
    image: "/media/cover-e.jpg",
    sections: [
      {
        h: "Уход за премиальным пуховиком",
        ps: [
          "Стирайте пуховик не чаще одного-двух раз за сезон и только жидкими средствами для пуха: порошок склеивает пушинки. Режим — деликатный, температура до 30 градусов, отжим минимальный.",
          "Сушите горизонтально с тремя-четырьмя теннисными мячами в барабане или встряхивая вручную каждые пару часов — так пух распределится равномерно и не собьётся в комки. Никаких батарей и прямого солнца.",
        ],
      },
      {
        h: "Уход за пальто с меховой отделкой",
        ps: [
          "Если меховые детали съёмные — отстёгивайте их перед чисткой пальто и храните отдельно в дышащем чехле. Несъёмный мех доверяйте только химчисткам, работающим с натуральным мехом.",
          "Кашемировое полотно очищайте специальной щёткой по направлению ворса, катышки снимайте машинкой для трикотажа. После дождя или снега — сушка на широких плечиках при комнатной температуре.",
        ],
      },
      {
        h: "Летнее хранение",
        ps: [
          "И пуховик, и пальто с мехом храните в тканевых чехлах в прохладном сухом месте, не сжимая соседними вещами. Вакуумные пакеты запрещены: пух и мех теряют объём безвозвратно.",
          "Клиенты Angiolini получают персональные рекомендации по уходу за каждой купленной вещью — а записаться на сезонное обслуживание можно в приложении в пару касаний.",
        ],
      },
    ],
  },
];
